import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-14" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Simular")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_9 = { style: {"padding":"10px"} }
const _hoisted_10 = { style: {"padding":"10px"} }
const _hoisted_11 = { style: {"padding":"10px"} }
const _hoisted_12 = { style: {"padding":"10px"} }
const _hoisted_13 = {
  key: 0,
  style: {"display":"block","padding":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_campo_cep = _resolveComponent("campo-cep")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_card = _resolveComponent("card")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_collapse, { accordion: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_collapse_panel, {
          key: "1",
          header: "Simulador de Fretes"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_spin, {
              spinning: _ctx.state.buscandoFretes
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_alert, {
                  message: "Para que o simulador funcione corretamente, as informações de peso e medidas precisam ser salvas previamente.",
                  banner: ""
                }),
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_a_form_item, { label: "CEP Destino" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_cep, {
                          valor: _ctx.state.cotacaoFrete.cep,
                          "onUpdate:valor": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.cotacaoFrete.cep) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_a_form_item, { label: "Quantidade na Venda" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.cotacaoFrete.quantidade) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.cotacaoFrete.quantidade]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_a_form_item, { label: " " }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "ui-button -primary ui-full",
                          type: "button",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.simularFrete()))
                        }, _hoisted_6)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                ((_ctx.state.opcoesFretes.length > 0))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.opcoesFretes, (opcaoFrete, index) => {
                          return (_openBlock(), _createBlock(_component_card, {
                            key: index,
                            titulo: ""
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_9, [
                                _createTextVNode("Nome:"),
                                _createElementVNode("b", null, _toDisplayString(opcaoFrete.nome), 1)
                              ]),
                              _createElementVNode("span", _hoisted_10, [
                                _createTextVNode("Código Serviço:"),
                                _createElementVNode("b", null, _toDisplayString(opcaoFrete.codigoServico), 1)
                              ]),
                              _createElementVNode("span", _hoisted_11, [
                                _createTextVNode("Prazo:"),
                                _createElementVNode("b", null, _toDisplayString(opcaoFrete.prazoEntrega) + " dias", 1)
                              ]),
                              _createElementVNode("span", _hoisted_12, [
                                _createTextVNode("Valor: "),
                                _createElementVNode("b", null, "R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(opcaoFrete.valorFrete,2)), 1)
                              ]),
                              (opcaoFrete.detalhesRegraFrete)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(opcaoFrete.detalhesRegraFrete), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.mensagemRetornoFrete)
                  ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                      key: 1,
                      mensagem: _ctx.state.mensagemRetornoFrete
                    }, null, 8, ["mensagem"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["spinning"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}